export enum ServiceFeeType {
    Normal = 1,
    Hierarchy = 2
}